export default __webpack_public_path__ + "static/016-59c14653d4af8d7a00e94ecdec7a68f0.jpg";